export const accountCodeField = 'codiceConto';
export const pinTemporaryField = 'pinConto';
export const pinRechargeField = 'pinRicarica';

export type SignupPDVFormType = {
  codiceConto: string;
  pinRicarica: string;
  pinConto: string;
};
